import { render, staticRenderFns } from "./CustomValidationRulesTable.vue?vue&type=template&id=086cd9e0"
import script from "./CustomValidationRulesTable.vue?vue&type=script&lang=js"
export * from "./CustomValidationRulesTable.vue?vue&type=script&lang=js"
import style0 from "./CustomValidationRulesTable.vue?vue&type=style&index=0&id=086cd9e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports